import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetLandingPageDomain as GetLandingPageDomainQuery} from 'nutshell-graphql-types';

import GET_LANDING_PAGE_DOMAIN from '../queries/get-landing-page-domain.graphql';

export const useGetLandingPageDomain = () => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetLandingPageDomainQuery, Record<any, any>>(GET_LANDING_PAGE_DOMAIN, {
        fetchPolicy: 'cache-and-network',
    });

    const landingPageDomain = data ? data.landingPageDomain : null;

    return {
        landingPageDomain,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
